<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          数据统计
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
export default {
  name: 'ZjDataAnalysisHeguHome',
  controller: 'UI',
  action: 'Home'
}  
</script>
